import React from 'react';
import { motion } from 'motion/react';
import { CheckIcon, CrossCircledIcon } from '@radix-ui/react-icons';

const PasswordCriteria = ({ password }) => {
    const criteria = [
        {
            label: 'At least 6 characters long',
            test: (pass) => pass.length >= 6
        },
        {
            label: 'Maximum 20 characters',
            test: (pass) => pass.length <= 20
        },
        {
            label: 'Contains at least one number',
            test: (pass) => /\d/.test(pass)
        },
        {
            label: 'Contains at least one uppercase letter',
            test: (pass) => /[A-Z]/.test(pass)
        }
    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="bg-background/80 backdrop-blur-sm border rounded-lg p-3 space-y-2 shadow-lg"
        >
            <p className="text-sm font-medium text-muted-foreground mb-2">Password requirements:</p>
            <ul className="space-y-1">
                {criteria.map((criterion, index) => {
                    const isMet = password ? criterion.test(password) : false;
                    return (
                        <motion.li
                            key={index}
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: index * 0.1 }}
                            className={`text-sm flex items-center gap-2 ${
                                isMet ? 'text-primary' : 'text-muted-foreground'
                            }`}
                        >
                            {isMet ? (
                                <CheckIcon className="h-4 w-4 shrink-0" />
                            ) : (
                                <CrossCircledIcon className="h-4 w-4 shrink-0 opacity-50" />
                            )}
                            {criterion.label}
                        </motion.li>
                    );
                })}
            </ul>
        </motion.div>
    );
};

export default PasswordCriteria; 